import React from 'react';
import {Route, Switch, withRouter,} from 'react-router';

import Auth from './scenes/auth';
import Dashboard from './scenes/dashboard';
import Notification from './components/Notifications';
import ConfirmModal from './components/ConfirmModal';

import 'react-image-lightbox/style.css';
import './utils/Polyfills';
import WebChat from './components/WebChat';

const App = () => {
    return (
        <div className="app">
            <Switch>
                <Route path="/dashboard/invitation-register/:token" component={Auth}/>
                <Route path="/dashboard" component={Dashboard}/>
                <Route exact path="/" component={Dashboard}/>
                <Route exact path="/login" component={Auth}/>
                <Route exact path={"/forgot"} component={Auth}/>
                <Route path={"/reset-password/:token"} component={Auth}/>
            </Switch>
            <Notification/>
            <ConfirmModal/>
            <WebChat/>
        </div>
    );
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.jsx